import { createFileRoute } from '@tanstack/react-router'
import AgreementsList from 'Royalty/components/AgreementsList'

export const Route = createFileRoute('/royalty/agreements')({
    component: AgreementsList,
})
